import { render, staticRenderFns } from "./homeProductSwiper.vue?vue&type=template&id=cde96e40&scoped=true&"
import script from "./homeProductSwiper.vue?vue&type=script&lang=js&"
export * from "./homeProductSwiper.vue?vue&type=script&lang=js&"
import style0 from "./homeProductSwiper.vue?vue&type=style&index=0&id=cde96e40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde96e40",
  null
  
)

export default component.exports